// Images with Text Scrolling Component
class ImagesWithTextScrolling extends HTMLElement {
  connectedCallback() {
    // 在视口中可见时触发动画
    if (window.IntersectionObserver) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this._reveal();
            observer.unobserve(this);
          }
        });
      }, { rootMargin: '-100px' });
      
      observer.observe(this);
    }

    // 如果有滚动体验效果
    if (this.hasAttribute('scrolling-experience')) {
      // 修复：只选择img元素，避免影响video和iframe
      this._imageToTransitionItems = Array.from(
        this.querySelectorAll('.images-scrolling-desktop__media-wrapper > img:not(:first-child)')
      );
      this._mainImage = this.querySelector('.images-scrolling-desktop__media-wrapper > img:first-child');
      this._contentItems = Array.from(this.querySelectorAll('.images-scrolling__content'));
      
      if (this._imageToTransitionItems.length > 0) {
        window.addEventListener('scroll', this._throttle(this._onScroll.bind(this), 16));
      }
    }
  }

  _reveal() {
    // 显示所有需要动画的标题元素
    const headingsToReveal = Array.from(this.querySelectorAll('[reveal-on-scroll="true"]'));
    headingsToReveal.forEach((heading, index) => {
      setTimeout(() => {
        if (heading.style) {
          heading.style.opacity = '1';
          heading.style.transform = 'translateY(0)';
          heading.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        }
      }, index * 100);
    });
  }

  _onScroll() {
    if (!this._mainImage || !this._contentItems.length) return;

    const imageRect = this._mainImage.getBoundingClientRect();
    const imageBottom = imageRect.bottom;
    const imageEffect = this.getAttribute('scrolling-experience');

    for (const [index, contentItem] of this._contentItems.entries()) {
      const contentItemRect = contentItem.getBoundingClientRect();
      const image = this._imageToTransitionItems[index - 1];
      const content = this._contentItems[index];

      if (contentItemRect.top < imageBottom - imageRect.height * 0.1 && 
          contentItemRect.bottom > imageBottom) {
        
        if (image && !image.classList.contains('is-visible')) {
          image.classList.add('is-visible');
          this._transitionImage(image, content, imageEffect, 'in');
        }
        break;
      }

      if (contentItemRect.top > imageBottom - imageRect.height * 0.1) {
        if (image && image.classList.contains('is-visible')) {
          image.classList.remove('is-visible');
          this._transitionImage(image, content, imageEffect, 'out');
        }
        break;
      }
    }
  }

  _transitionImage(image, content, effect, direction) {
    // 增加安全检查：确保只对img元素应用动画
    if (!image || image.tagName !== 'IMG') {
      return;
    }
    
    const duration = 350;
    const isIn = direction === 'in';
    
    if (effect === 'fade') {
      // 淡入淡出效果
      image.style.transition = `opacity ${duration * 0.6}ms ease`;
      content.style.transition = `opacity ${duration}ms ease`;
      
      image.style.opacity = isIn ? '1' : '0';
      content.style.opacity = isIn ? '1' : '0';
    } else {
      // 遮罩揭示效果
      image.style.transition = `opacity 0ms, clip-path ${duration}ms cubic-bezier(0.99, 0.01, 0.5, 0.94)`;
      content.style.transition = `opacity ${duration}ms ease`;
      
      if (isIn) {
        image.style.opacity = '1';
        image.style.clipPath = 'inset(0 0 0 0)';
        content.style.opacity = '1';
      } else {
        image.style.clipPath = 'inset(100% 0 0 0)';

        content.style.opacity = '0';
        setTimeout(() => {
          if (!image.classList.contains('is-visible')) {
            image.style.opacity = '0';
          }
        }, duration);
      }
    }
  }

  _throttle(func, limit) {
    let inThrottle;
    return function() {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    }
  }
}

// 注册自定义元素
if (!window.customElements.get('images-with-text-scrolling')) {
  window.customElements.define('images-with-text-scrolling', ImagesWithTextScrolling);
}
